<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="users-template template-page" v-else-if="loaded" > 

        <tagsComponent v-if="rows" :data="rows" :leadID="ID" ></tagsComponent>
                
    </div>
</template>

<script>
    
import tagsComponent from '../../components/tags.vue' 
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import moment from 'moment'
import helper from '@/helpers/helpers.js';

export default{
    name: "LeadTags",
    components:{
        tagsComponent
    },
    props: {
        ID: { 
            type: [Number, String],
        },
    },
    data () {
        return {
            filter: '',
            rows: [],
            loaded: false,
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        
        this.get_data();
        //this.get_LeadData()
        
    },
    computed: {
    },
    methods: {
    
        get_data(){
          
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/leads/'+this.ID+'/tags').orderBy('datetime', 'desc');

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                results.push( item )
                                //console.log(item)
                                
                                this.rows = results
                                
                                return results;
                        })
                    )
                    .then(results => {                        
                        //return results;   
                        this.loaded = true;
                    })

                })
            
        },

    },
    computed:{
        getOrganizationID(){
            return this.$store.getters.getOrganizationID
        },
    }
}
</script>

<style >
    
</style>


// WEBPACK FOOTER //
// src/templates/leads/Timeline.vue